import { useEffect, useState } from 'react';
import { getPropertyBookingLinks } from 'src/services/client';
import {
  ICalcomApiResult,
  IPropertyBookingLink,
  JuniperEventType,
} from 'src/pages/Calendar/CalcomIntegration/types';

export interface IUsePropertyBookingLinks {
  links: IPropertyBookingLink[];
  isLoading: boolean;
  error: string | null;
  hasNoLinks: boolean;
  refetch: () => Promise<void>;
}

export const usePropertyBookingLinks = (
  propertyId: string,
  kind: JuniperEventType
): IUsePropertyBookingLinks => {
  const [links, setLinks] = useState<IPropertyBookingLink[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLinks = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    const result: ICalcomApiResult<IPropertyBookingLink[]> =
      await getPropertyBookingLinks(propertyId, kind);

    if (!result.ok) {
      setError(result.error ?? 'Failed to fetch booking links');
      setIsLoading(false);
      return;
    }

    setLinks(result.data ?? []);
    setIsLoading(false);
  };

  const hasNoLinks: boolean =
    !isLoading && error === null && links.length === 0;

  useEffect(() => {
    void fetchLinks();
  }, [propertyId, kind]);

  return {
    links,
    isLoading,
    error,
    hasNoLinks,
    refetch: fetchLinks,
  };
};
